(function () {
  angular.module('MktzapApp.Factories')
    .factory('CampaignManagementFormService', campaignManagementFormService);

  campaignManagementFormService.$inject = ['$resource'];
  function campaignManagementFormService ($resource) {
    return $resource('', {}, {
      getChannels: { url: frontUrl + '/channels/index', method: 'GET', isArray: false },
      getSubChannels: { url: frontUrl + '/get-sub-channels', method: 'GET', isArray: false },
      getListHsm: { url: frontUrl + '/get-list-hsm', method: 'GET', isArray: false },
      getSectors: { url: frontUrl + '/get-sectors', method: 'GET', isArray: false },
      getCampaign: { url: frontUrl + '/campaign-management/show/:id', method: 'GET', isArray: false },
      saveCampaign: { url: frontUrl + '/campaign-management/save', method: 'POST', isArray: false },
      updateCampaign: { url: frontUrl + '/campaign-management/update/:id', method: 'POST', params: { id: '@id', _method: 'PUT' }, isArray: false },
    });
  }
})();
